import { createContext, useContext } from 'react';
import { Property } from '@model';

export type ShareDialogModel = {
  hideShareDialog: () => void;
  showShareDialog: (property: Property) => void;
  shareDialogProperty: Property | undefined;
};

export const ShareDialogContext = createContext<ShareDialogModel>({
  hideShareDialog: () => {},
  showShareDialog: () => {},
  shareDialogProperty: undefined,
});

export const useShareDialog = () => useContext(ShareDialogContext);
